import React from 'react';
import { Link } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import PropTypes from 'prop-types';
import { trackBuyItAgainCheckoutClicked } from '../../../apis/newRelicTrackingApi';
import useSiteData from '../../../hooks/useSiteData';
import { getShopperId } from '../../../util/auth';
import { useLineItemData } from '../../contexts/LineItemDataProvider';
import { BUY_IT_AGAIN_SOURCE_PAGE } from '../../../constants/orderdetailsui';

export const CheckoutCta = ({ sourcePage }) => {
  const [buyItAgainMessages] = useTranslations(['buyItAgainMessages']);

  const { vistacartTenant: vistacartTenantName, externalAppNavigation: nav } =
    useSiteData();

  const shopperId = getShopperId();

  const item = useLineItemData();
  const { id, orderNumber } = item;

  const checkoutUrl = nav.checkout;

  const checkoutLinkHandler = e => {
    e.preventDefault();

    if (sourcePage === BUY_IT_AGAIN_SOURCE_PAGE) {
      const trackingData = {
        orderNumber,
        itemId: id,
        vistacartTenantName,
        page: sourcePage,
      };
      trackBuyItAgainCheckoutClicked(shopperId, trackingData);
    }

    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };

  return (
    <Link
      href={checkoutUrl}
      onClick={checkoutLinkHandler}
      skin="cta"
      textColor="white"
    >
      {buyItAgainMessages.checkout}
    </Link>
  );
};

CheckoutCta.propTypes = {
  sourcePage: PropTypes.string,
};
